import { SettingsNavigation } from './SettingsNavigation'

export default SettingsNavigation
